import { render, staticRenderFns } from "./toText.vue?vue&type=template&id=21a34273"
import script from "./toText.vue?vue&type=script&lang=js"
export * from "./toText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports